const CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;

// function sanitizePublicId(filename) {
//     return filename
//         .replace(/\.[^/.]+$/, '')          // retire l'extension
//         .replace(/\s+/g, '_')              // espaces → underscores
//         .replace(/[^a-zA-Z0-9_\-\/]/g, '') // caractères spéciaux
//         .toLowerCase();
// }

function buildUrl(publicId, options = {}) {
    if (!publicId) return null;
    if (publicId.startsWith('http')) return publicId; // sécurité, ne devrait plus arriver

    const base = `https://res.cloudinary.com/${CLOUD_NAME}/image/upload`;
    const transforms = ['f_auto', 'q_auto'];
    if (options.width) transforms.push(`w_${options.width}`);
    if (options.height) transforms.push(`h_${options.height}`);

    return `${base}/${transforms.join(',')}/${publicId}`;
}

/**
 * La colonne `image` en base peut contenir plusieurs public_ids séparés
 * par des virgules (ex: "products/p_1,products/p_2"). Une seule image
 * = pas de virgule = comportement identique à avant.
 */
function splitImageField(image) {
    if (!image) return [];
    return image.split(',').map((s) => s.trim()).filter(Boolean);
}

/**
 * Une seule image — à utiliser PARTOUT sauf dans la galerie produit
 * (dashboard admin, cartes produit, favoris, panier...).
 * Prend toujours la première image même si le produit en a plusieurs.
 */
export function getProductImage(image, options = {}) {
    if (!image) return '/placeholder.png';
    const first = splitImageField(image)[0];
    return buildUrl(first, options) || '/placeholder.png';
}

/**
 * Toutes les images d'un produit, dans l'ordre — à utiliser uniquement
 * pour la galerie façon Amazon/Jumia (VusProduct).
 */
export function getProductImages(image, options = {}) {
    const ids = splitImageField(image);
    if (ids.length === 0) return ['/placeholder.png'];
    return ids.map((id) => buildUrl(id, options));
}

/**
 * Les public_ids bruts (sans URL construite) — utilisé côté admin pour
 * savoir quelles images existantes garder/retirer lors d'une édition.
 */
export function getProductImagePublicIds(image) {
    return splitImageField(image);
}
